import { render, staticRenderFns } from "./process-design-list.vue?vue&type=template&id=7231d8da&"
import script from "./process-design-list.vue?vue&type=script&lang=js&"
export * from "./process-design-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports